export const filterAdapters = <T extends object>(obj: T, adaptersToShow: Array<keyof T>): Partial<T> => {
  const filtered = Object.entries(obj).filter(([key]) => adaptersToShow.includes(key as keyof T));

  return Object.fromEntries(filtered) as Partial<T>;
};
